export default {
  name: 'language-switcher',

  componentDidMount () {
    this.el.addEventListener('change', e => {
      const value = this.el.value
      window.location.href = value
    })
  },

  componentWillUnmount () {},
}
